import { LanguageEnum } from '../enums';
import { ReportTypeEnum } from '../enums/report-type.enum';

export interface MailConfig {
  configId: number | null;
  configName: string | null;
  language?: LanguageEnum;
  reportType?: ReportTypeEnum;
  recipients: string[];
}

export namespace MailConfig {
  export function mapFromApiValue(mailConfig: any): MailConfig | null {
    if (!mailConfig) {
      return null;
    }
    return {
      configId: mailConfig.configId,
      configName: mailConfig.configName,
      reportType: ReportTypeEnum.mapFromApiValue(mailConfig.reportType),
      language: mailConfig.language && LanguageEnum.mapFromApiValue(mailConfig.language),
      recipients: mailConfig.recipients,
    };
  }
}
